var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero-section"},[_c('div',{staticClass:"hero-bg"},[_c('div',{staticClass:"hero-gradient"})])])
}]

export { render, staticRenderFns }